import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { CloseOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { Label, Wrapper, Box } from './styled'
import { ModalRequester } from '../modal-requester'
import { useProfile, useTaskManagement } from '../../../../hooks'
import { TASK_TYPE_NAME } from '../../constants'

export const Requester = ({ t, taskCategory, registeredRequester, setRegisteredRequester, disabled }) => {
  const { profile: { userId, fullName } } = useProfile()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedRequester, setSelectedRequester] = useState(null)
  const { sortedUserList } = useTaskManagement()
  const { taskTypeName } = taskCategory
  const isMyTask = taskTypeName === TASK_TYPE_NAME.MY_TASK

  useEffect(() => {
    if (isMyTask) {
      // マイタスクのときはログインユーザーを設定する
      const requester = { id: userId, name: fullName }
      setRegisteredRequester(requester)
      setSelectedRequester(requester)
    }
  }, [taskTypeName, userId, fullName])

  const handleOpen = () => {
    if (disabled) return
    setIsModalVisible(true)
  }

  const handleRemove = (e) => {
    e.stopPropagation()
    setRegisteredRequester(null)
    setSelectedRequester(null)
  }

  return (
    <>
      <Wrapper>
        <Label>{t('task.requester')}</Label>
        <Box onClick={handleOpen}>
          {registeredRequester && (
          <div
            key={registeredRequester.id}
            className="user-item"
            role="button"
            tabIndex={0}
            onClick={(e) => e.stopPropagation()}
          >
            <span>{registeredRequester.name}</span>
            {!disabled && (
            <Tooltip title={t('common.delete')}>
              <button className="remove-item" onClick={(e) => handleRemove(e)} disabled={isMyTask} type="button">
                <CloseOutlined />
              </button>
            </Tooltip>
            )}
          </div>
          )}
        </Box>
      </Wrapper>
      <ModalRequester
        t={t}
        requesterList={sortedUserList}
        selectedRequester={selectedRequester}
        setSelectedRequester={setSelectedRequester}
        registeredRequester={registeredRequester}
        setRegisteredRequester={setRegisteredRequester}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  )
}

Requester.propTypes = {
  t: PropTypes.func,
  taskCategory: PropTypes.object,
  registeredRequester: PropTypes.object,
  setRegisteredRequester: PropTypes.func,
  disabled: PropTypes.bool
}
